module.exports = __webpack_public_path__ + "static/media/monkey-bubble-shooter.39357b82.png";